import Vue from 'vue';
import commonLists from './commonListsPlugin';

Vue.use(commonLists);

Vue.prototype.$commonLists.populate([
    { name: 'employees', list: [], api: 'api/employees/GetAllForList'},
    { name: 'serviceProviders', list: [], api: 'api/employees/GetServiceProviders' },
    { name: 'serviceLocations', list: [], api: 'api/ServicePlaces/GetAllForList' },
    { name: 'visitTypes', list: [], api: 'api/visittypes/getforlist' },
    { name: 'readyVisits', list: [], api: 'api/readyvisits/getforlist' },
    { name: 'clientsGroups', list: [], api: 'api/clients/getgroupsforlist' },
    { name: 'taxes', list: [], api: 'api/taxes/GetTaxes' },
    { name: 'sponsors', list: [], api: 'api/sponsors/getall' }
])


